const updateVariantInput = () => {
  const productForms = document.querySelectorAll(
    `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
  );
  productForms.forEach((productForm) => {
    const input = productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });
};

const updateVariantStatuses = () => {
  const selectedOptionOneVariants = this.variantData.filter(
    (variant) => this.querySelector(":checked").value === variant.option1
  );
  const inputWrappers = [...this.querySelectorAll(".product-form__input")];
  inputWrappers.forEach((option, index) => {
    if (index === 0) return;
    const optionInputs = [
      ...option.querySelectorAll('input[type="radio"], option'),
    ];
    const previousOptionSelected =
      inputWrappers[index - 1].querySelector(":checked").value;
    const availableOptionInputsValue = selectedOptionOneVariants
      .filter(
        (variant) =>
          variant.available &&
          variant[`option${index}`] === previousOptionSelected
      )
      .map((variantOption) => variantOption[`option${index + 1}`]);
    this.setInputAvailability(optionInputs, availableOptionInputsValue);
  });
};

const setInputAvailability = (listOfOptions, listOfAvailableOptions) => {
  listOfOptions.forEach((input) => {
    if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
      input.innerText = input.getAttribute("value");
    } else {
      input.innerText = window.locales.unavailable_with_option.replace(
        "[value]",
        input.getAttribute("value")
      );
    }
  });
};

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
};

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        const pID = this.form.querySelector("[name=id]");
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;
        if (pID) {
          pID.disabled = false;
        }
        this.shareButton = this.querySelector('[name="share-block"]');
        this.closeShareButton = document.querySelector(".share-block .close");
        this.reviewStars = this.querySelector("[product-form-review-stars]");
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.variantSelects = this.querySelector("variant-radios");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButton.addEventListener(
          "click",
          this.onFormSubmit.bind(this)
        );
        this.form.addEventListener("submit", this.onSubmitHandler);
        if (this.shareButton) {
          this.shareButton.addEventListener("click", this.toggleShareBlock);
        }
        if (this.reviewStars) {
          this.reviewStars.addEventListener(
            "click",
            this.onStarsClick.bind(this)
          );
        }
        if (this.closeShareButton) {
          this.closeShareButton.addEventListener(
            "click",
            this.toggleShareBlock
          );
        }
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.variantData = this.querySelector(
          "script[data-variant-data]"
        )?.innerHTML;
        this.variantOptionLabels = this.querySelectorAll(
          ".variant-option__label"
        );

        this.variantOptionLabels.forEach((label) => {
          label.addEventListener("mouseenter", this.onLabelHover.bind(this));
        });

        this.variantDataJSON = JSON.parse(this.variantData?.replace(",}", "}"));
        this.init();
      }

      onStarsClick(e) {
        e.preventDefault();
        const accordion = document.querySelector(
          ".product-page-reviews-accordion"
        );
        if (accordion) {
          const button = accordion.querySelector(".accordion");
          const panel = accordion.querySelector(".panel");
          button.classList.add("active");
          panel.style.maxHeight = panel.scrollHeight + "px";
          panel.classList.add("open");
          window.scrollTo({
            top: button.offsetTop,
            behavior: "smooth",
          });
        }
      }

      onFormSubmit(e) {
        if (window.graphenehc) {
          const prodID = this.querySelector("[name='product-id']").value;
          window.graphenehc.track({
            scope: "basket",
            action: "add",
            data: {
              product_id: parseFloat(prodID),
            },
          });
          console.log("Graphene ATC fired");
        }
      }

      onWishlistSubmit(e) {
        const loggedIn = window.Moonbase?.customer?.logged_in || false;
        if (loggedIn) {
          let data = {};
          let ometriaNamespace = "UK:"; // Set default to UK
          data.contact_id = Math.floor(Math.random() * 1000000);
          data.email_address = window.Moonbase?.customer?.customer_email || "";
          if (ometria.raw_data.namespace) {
            ometriaNamespace = ometria.raw_data.namespace;
          }
          data.product_id = `${ometriaNamespace}${
            this.querySelector("[name='product-id']").value
          }`;
          const json = JSON.stringify(data);
          fetch(window.Moonbase.api.ometria.wishlist, {
            method: "POST",
            body: json,
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.status === "OK") {
                console.log("Wishlist item submitted to Ometria", data);
              } else {
                console.error(
                  "There was an error submitting the wishlist item",
                  data
                );
              }
            })
            .catch((error) => {
              console.info(
                "There was an error in retrieving the Ometria Data",
                error
              );
            })
            .finally(() => {});
        }
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        // this.input.min = min;
        // this.input.max = max;
        // this.input.value = min;
        // publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading-overlay"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading-overlay"
            ).classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );

        const variantMessageField = html.getElementById(
          `variant-metafield-message`
        );
        // Find teh currently #variant-metafield-message and replace it with the new one
        const variantMessageFieldCurrent = this.querySelector(
          `#variant-metafield-message`
        );
        if (variantMessageField.innerHTML.split(" ").join("").length > 5) {
          variantMessageFieldCurrent.classList.remove("hidden");
          variantMessageFieldCurrent.innerHTML = variantMessageField.innerHTML;
        } else {
          variantMessageFieldCurrent.classList.add("hidden");
        }

        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null)
                current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      init() {
        if (this.variantDataJSON) {
          this.showSecondarySizes();
        }

        const wishlistInterval = setInterval(() => {
          const wishlistButton = this.querySelector(".swym-add-to-wishlist");
          if (wishlistButton) {
            clearInterval(wishlistInterval);
            wishlistButton.addEventListener("click", (e) => {
              this.onWishlistSubmit(e);
            });
          }
        }, 1000);

        const b2bInventoryInfo = this.querySelector('.product-dispatch-message--b2b');
        if (b2bInventoryInfo) {
          this.fetchLocationInfoB2b()
          this.setWarehouseAvailability()
        }
      }

      onLabelHover(e) {
        const el = e.target;
        const valueEl = el;
        if (!valueEl) return;
        const matchingVariant = this.variantDataJSON.find(
          (variant) => variant.option === valueEl.dataset.option
        );
        const variantMessageField = document.querySelector(
          "#variant-metafield-message"
        );
        if (matchingVariant && matchingVariant.message) {
          variantMessageField.innerHTML = matchingVariant.message;
          variantMessageField.classList.remove("hidden");
        } else {
          variantMessageField.classList.add("hidden");
        }
      }

      toggleShareBlock(event) {
        event.preventDefault();
        const productForm = document.querySelector("product-form");
        const shareBlock = productForm.querySelector(".share-block");
        shareBlock.classList.toggle("hidden");
      }

      showSecondarySizes() {
        this.variantOptionLabels.forEach((label) => {
          const valueEl = label.querySelector(".value");
          const oosSVG = label.querySelector("svg");
          const valueInt = parseInt(valueEl.textContent);
          if (!valueEl) return;
          const matchingVariant = this.variantDataJSON.find(
            (variant) => parseInt(variant.option) === valueInt
          );
          if (!matchingVariant) return;
          if (matchingVariant.metafield_size) {
            valueEl.textContent = `${valueEl.textContent} / ${matchingVariant.metafield_size}`;
          }
        });
      }

      onSubmitHandler(event) {
        event.preventDefault();
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButton.classList.add("loading");
        setTimeout(() => {
          this.submitButton.classList.remove("loading");
        }, 2000);
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      fetchLocationInfoB2b() {
        const checkForInventoryInfo = setInterval(async function () {
          if (window.inventoryInfo) {
            clearInterval(checkForInventoryInfo);
            let url = `https://rest.locationinventory.info/v1/inventory?shop=${Shopify.shop}&handle=${window.inventoryInfo.product.handle}&id=${window.inventoryInfo.product.id}`;
            let response = await fetch(url);
            window.variantInventoryInfo = await response.json();
          }
        }, 66);
      }

      async setWarehouseAvailability() {
        const despatchMessage = document.querySelector(".product-dispatch-message");
        const despatchMessageLineProperty = document.querySelector("#line-item-property__despatch-message");
        let locationFound = false;
        const checkForInventoryInfo = setInterval(function () {
          if (window.variantInventoryInfo) {
            clearInterval(checkForInventoryInfo);
            const inventoryObj = window.variantInventoryInfo;
            const inventoryLocations = inventoryObj.variantLocations;
            if (!inventoryLocations) return;
            const checkForWarehouseInformation = setInterval(function () {
              if (window.warehouses) {
                clearInterval(checkForWarehouseInformation);
                const warehouses = window.warehouses;
                for (const warehouse in warehouses) {
                  const storeName = warehouses[warehouse].name;
                  const warehouseInventory = inventoryLocations.find(
                    (inventory) => inventory.variant == formID
                  );
                  if (!warehouseInventory) continue;
                  const warehouseLocation = warehouseInventory.inventoryLocations.find(
                    (inventory) => inventory.location.name == storeName
                  );

                  if (!warehouseLocation) continue;
                  if (warehouseLocation.quantity > 0) {
                    despatchMessage.classList.add("show-delivery-message");
                    despatchMessage.classList.remove("hidden");
                    despatchMessage.querySelector("span").innerHTML =
                      warehouses[warehouse].message;
                    if (!despatchMessageLineProperty) return;
                    despatchMessageLineProperty.value =
                      warehouses[warehouse].message;
                    locationFound = true;
                    break;
                  }
                }
                if (locationFound) return;
                console.warn(`No matching warehouse location found for variant`);
                despatchMessage.classList.remove("show-delivery-message");
                despatchMessage.classList.add("hidden");
              }
            }, 66);
          }
        }, 66);
      }
    }
  );
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.init();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateFormInputID();
    if (!this.currentVariant) {
      this.setUnavailable();
    } else if (this.currentVariant.available == false) {
      this.updateBuyButton();
      this.updateMedia();
      this.updateURL();
      this.updateSKU();
      this.updateID();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.setWarehouseAvailability(true);
      document.dispatchEvent(new CustomEvent("swym:variant-unavailable"));
    } else {
      this.updateBuyButton();
      this.updateMedia();
      this.updateURL();
      this.updateSKU();
      this.updateID();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.setWarehouseAvailability(true);
    }
  }

  init() {
    this.setWarehouseAvailability(false);
    this.initVariantLocationInfo();
  }

  async initVariantLocationInfo() {
    const checkForInventoryInfo = setInterval(async function () {
      if (window.inventoryInfo) {
        clearInterval(checkForInventoryInfo);
        let response = await fetch(`https://rest.locationinventory.info/v1/inventory?shop=${Shopify.shop}&handle=${window.inventoryInfo.product.handle}&id=${window.inventoryInfo.product.id}`);
        window.variantInventoryInfo = await response.json();
      }
    }, 66);
  }

  updateSKU() {
    // Get the this.variant and get the sku from the script[data-variant-data] element
  }

  updateBuyButton() {
    const buyButton = document.querySelector(".product-form__submit");
    const stickyBuyButton = document.querySelector("#sticky-add-to-cart");
    if (!buyButton) return;
    buyButton.removeAttribute("disabled");
    stickyBuyButton.innerText = window.locales.addToCart;
    document.body.classList.add("variant-selected");
    buyButton.innerText = window.locales.addToCart;
  }

  async fetchUserJSON() {
    let response = await fetch(`/browsing_context_suggestions.json`);
    let data = await response.json();
    return data.detected_values;
  }

  async setWarehouseAvailability(clickEvent) {
    const userGeoData = await this.fetchUserJSON();
    const despatchMessage = document.querySelector(".product-dispatch-message");
    const despatchMessageLineProperty = document.querySelector(
      "#line-item-property__despatch-message"
    );
    let locationFound = false;
    const checkForInventoryInfo = setInterval(function () {
      if (window.variantInventoryInfo) {
        clearInterval(checkForInventoryInfo);
        const inventoryObj = window.variantInventoryInfo;
        const inventoryLocations = inventoryObj.variantLocations;
        const formID = document.querySelector(".product-variant-id").value;
        if (!inventoryLocations) return;
        const checkForWarehouseInformation = setInterval(function () {
          if (window.warehouses) {
            clearInterval(checkForWarehouseInformation);
            const warehouses = window.warehouses;
            for (const warehouse in warehouses) {
              const storeName = warehouses[warehouse].name;
              const warehouseInventory = inventoryLocations.find(
                (inventory) => inventory.variant == formID
              );
              const warehouseLocation =
                warehouseInventory.inventoryLocations.find(
                  (inventory) => inventory.location.name == storeName
                );
              if (!warehouseLocation) return;
              if (warehouseLocation.quantity > 0) {
                if (clickEvent === true) {
                  despatchMessage.classList.add("show-delivery-message");
                  despatchMessage.classList.remove("hidden");
                }
                despatchMessage.querySelector("span").innerHTML =
                  warehouses[warehouse].message;
                if (!despatchMessageLineProperty) return;
                despatchMessageLineProperty.value =
                  warehouses[warehouse].message;
                locationFound = true;
                break;
              }
            }
            if (locationFound) return;
            if (clickEvent === true) {
              despatchMessage.classList.remove("show-delivery-message");
              despatchMessage.classList.add("hidden");
            }
          }
        }, 66);
      }
    }, 66);
  }

  updateFormInputID() {
    const productForm = this.closest("product-form");
    if (!productForm) return;
    const input = productForm.querySelector(".product-variant-id");
    input.value = this.currentVariant.id;
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const gallerySwiper = document.querySelector(
      ".product-main__gallery"
    ).swiper;
    gallerySwiper.slideTo(this.currentVariant.featured_media.position - 1);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateID() {
    if (!this.currentVariant) return;
    const productInfo = document.querySelector(".product__form-visual-id span");
    const input = document.querySelector("#product_prima_messaging");
    const variantData = document.querySelector(
      "script[data-variant-data]"
    )?.innerHTML;
    const matchingVariant = JSON.parse(variantData).find(
      (variant) => variant.option === this.currentVariant.option1
    );
    if (!matchingVariant) return;
    let prop = "";
    if (
      this.currentVariant.name
        .toLowerCase()
        .includes(window.locales.gift_card_name.toLowerCase())
    ) {
      prop = `${matchingVariant.variant_prima_code}`;
    } else {
      prop = `${matchingVariant.prima_code}/${matchingVariant.matrix_1}/${matchingVariant.matrix_2}`;
    }
    input.value = prop;
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.locales.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.locales.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.classList.add("in-stock");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.classList.remove("in-stock");
      addButtonText.textContent = window.locales.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.locales.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-variant-json]").textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

// Create a web component for the quantity-input
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.minusButton = this.querySelector(".minus");
    this.plusButton = this.querySelector(".plus");
    this.quantityInput = this.querySelector(".quantity__input");
    this.minusButton.addEventListener("click", this.minusQty.bind(this));
    this.plusButton.addEventListener("click", this.addQty.bind(this));
    this.formQty = document.querySelector(".product-variant-qty");
  }

  minusQty() {
    if (this.quantityInput.value > 1) {
      this.quantityInput.value = this.quantityInput.value--;
    }
  }

  addQty() {
    this.quantityInput.value++;
    this.quantityInput.value = this.quantityInput.value++;
  }
}

customElements.define("quantity-input", QuantityInput);
